module.exports = __webpack_public_path__ + "img/publish.ccd9338.png";